export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/Animated_Gifs_fr-FR.88fd532.vtt";